import React from "react";

import { AlertTriangle } from "lucide-react";

import { cn } from "lib/utils";

type SlowStateBannerProps = {
  children: React.ReactNode;
  className?: string;
  actions?: React.ReactNode;
};

const SlowStateBanner = ({
  children,
  className,
  actions,
}: SlowStateBannerProps) => (
  <div
    className={cn(
      "flex flex-col gap-3 rounded-xl border border-amber-200 bg-amber-50/70 p-4 text-sm text-amber-700 md:flex-row md:items-center md:justify-between",
      className,
    )}
    role="alert"
  >
    <div className="flex items-start gap-3">
      <AlertTriangle className="mt-0.5 size-4 flex-none text-amber-600" aria-hidden />
      <div className="space-y-1">{children}</div>
    </div>
    {actions && <div className="flex flex-none items-center gap-2">{actions}</div>}
  </div>
);

export default SlowStateBanner;
